import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import ProviderServerlessToken from './provider-token';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';
// import { CreditCardIcon, Key, LogsIcon, TagIcon } from 'lucide-react';
// import { LightningBoltIcon } from '@radix-ui/react-icons';

const ServerlessLayout = () => {
  const { workspaceId } = useParamWorkspaceId();

  const navItems = [
    {
      href: PATH_PAGE.dashboard.serverlessGPU.overview(workspaceId),
      label: 'Projects',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.task(workspaceId),
      label: 'Tasks',
      strictMatch: true,
      // icon: <LogsIcon className="size-4" />,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.tokens(workspaceId),
      label: 'Tokens',
      strictMatch: true,
      // icon: <Key className="size-4" />,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.storageLogs(workspaceId),
      label: 'Storage Logs',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.blueprint(workspaceId).root,
      label: 'Blueprint',
      separator: true,
      // icon: <Key className="size-4" />,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.onboarding(workspaceId),
      label: 'Quickstart',
      strictMatch: true,
      // icon: <LightningBoltIcon className="size-4" />,
    },
    {
      href: PATH_PAGE.dashboard.serverlessGPU.pricing(workspaceId),
      label: 'Pricing',
      strictMatch: true,
      // icon: <TagIcon className="size-4" />,
    },
  ];

  const navbarConfig = useMemo(
    () => ({
      title: 'Serverless GPU',
      navbar: navItems,
    }),
    [workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <ProviderServerlessToken>
      <Outlet />
    </ProviderServerlessToken>
  );
};

export default ServerlessLayout;
